module.exports = __webpack_public_path__ + "img/home-rbn-3.db718afe.png";